import ConsultantDTO from '@src/adapters/dto/consultant/ConsultantDTO';
import useFindConsultantsVisibleLazy from '@src/adapters/hooks/consultants/useFindConsultantsVisible';
import useCachedList from './CachedList';

const ConsultantList = () => {
  return useCachedList<ConsultantDTO>(
    'consultantsList',
    useFindConsultantsVisibleLazy
  );
};

export default ConsultantList;
